"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var ProgressBarWrapper = /** @class */ (function (_super) {
    __extends(ProgressBarWrapper, _super);
    function ProgressBarWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressBarWrapper.prototype.findPercentageText = function () {
        return this.find('.awsui-progress-bar__percentage');
    };
    ProgressBarWrapper.prototype.findResultButton = function () {
        return this.find('.awsui-progress-bar__result-button button');
    };
    /**
     * Returns the result icon.
     *
     * @param resultState The resultState you expect the progress bar to be in.
     */
    ProgressBarWrapper.prototype.findResultIcon = function (resultState) {
        var iconType = resultState === 'success' ? 'positive' : 'negative';
        return this.find(".awsui-util-status-" + iconType);
    };
    return ProgressBarWrapper;
}(dom_1.ComponentWrapper));
exports.default = ProgressBarWrapper;
//# sourceMappingURL=awsui-progress-bar.js.map